export const runUpdater = async (
  allData,
  { customer, doctor, stage },
  columns,
  prop,
  value,
  id,
) => {
  if (prop === 'doctor') {
    allData[id].doctor = columns
      .find((c) => c.accessor === 'doctor')
      .options.find((t) => t.id === value);
  } else {
    allData[id][prop] = value;
  }

  return allData;
};
